import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { Send, Mail, Github, Twitter, ShieldCheck } from 'lucide-react';

const Footer = () => {
  const { config } = useSiteConfig();
  const site = config.site || {};
  return (
    <footer className="mt-20 border-t border-[var(--eh-border)] eh-grid-bg">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4"><Logo size={40} /><div className="eh-brand font-black tracking-widest eh-neon-soft">{site.name}</div></div>
          <p className="text-sm opacity-70 leading-7">{site.description}</p>
          <div className="flex gap-3 mt-4">
            <a className="opacity-70 hover:opacity-100" href="#" aria-label="GitHub"><Github size={18} /></a>
            <a className="opacity-70 hover:opacity-100" href="#" aria-label="Twitter"><Twitter size={18} /></a>
          </div>
        </div>
        <div>
          <div className="eh-mono text-xs tracking-[.3em] mb-4" style={{ color: 'var(--eh-green)' }}>// NAVIGATE</div>
          <ul className="space-y-2 text-sm">
            {config.nav.map(n => (
              <li key={n.to}><Link to={n.to} className="hover:text-[var(--eh-green)] transition-colors">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="eh-mono text-xs tracking-[.3em] mb-4" style={{ color: 'var(--eh-green)' }}>// COMPANY</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-[var(--eh-green)] transition-colors">About Us</Link></li>
            <li><Link to="/info/team" data-testid="footer-team" className="hover:text-[var(--eh-green)] transition-colors">The Team</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-[var(--eh-green)] transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-[var(--eh-green)] transition-colors">Terms of Use</Link></li>
            <li><Link to="/faq" className="hover:text-[var(--eh-green)] transition-colors">FAQ</Link></li>
            <li><Link to="/track" className="hover:text-[var(--eh-green)] transition-colors">Track Order</Link></li>
          </ul>
        </div>
        <div>
          <div className="eh-mono text-xs tracking-[.3em] mb-4" style={{ color: 'var(--eh-green)' }}>// CONTACT</div>
          {site.telegram && <a href={site.telegram} className="flex items-center gap-2 text-sm mb-2 hover:text-[var(--eh-green)]"><Send size={14} /> Telegram</a>}
          {site.email && <a href={`mailto:${site.email}`} className="flex items-center gap-2 text-sm hover:text-[var(--eh-green)]"><Mail size={14} /> {site.email}</a>}
          <div className="mt-5 text-sm space-y-2 eh-mono">
            <div className="flex items-center gap-2"><span className="w-2 h-2 rounded-full" style={{ background: 'var(--eh-green)', boxShadow: '0 0 10px var(--eh-green)' }} /> system : online</div>
            <div className="opacity-70">build : {site.version}</div>
            <div className="opacity-70">uptime : 99.98%</div>
            <div className="inline-flex items-center gap-1.5 mt-2 px-2 py-1 rounded-full border text-[10px]" style={{ borderColor: 'rgba(0,255,157,.35)', color: 'var(--eh-green)' }}>
              <ShieldCheck size={10} /> AUTHORIZED WORK ONLY
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-[var(--eh-border)] py-5 text-center eh-mono text-xs opacity-60 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
        <span>© {new Date().getFullYear()} {site.name} · All operations are authorised, ethical, and for educational use only.</span>
        <span className="hidden sm:inline opacity-50">·</span>
        <span className="flex gap-3 opacity-80">
          <Link to="/privacy" className="hover:text-[var(--eh-green)]">Privacy</Link>
          <Link to="/terms" className="hover:text-[var(--eh-green)]">Terms</Link>
          <Link to="/about" className="hover:text-[var(--eh-green)]">About</Link>
        </span>
      </div>
    </footer>
  );
};
export default Footer;
